import { post } from '../base';

import { Customization, CustomizationCreateUpdatePayload } from './types';

export function createProductCustomization({ customization }: { customization: CustomizationCreateUpdatePayload }) {
  return post('v5/product-customizations', { json: customization }).json<Customization>();
}
